import {
  randomString,
  getFormData,
  devOrProd,
  nuqliumDataIndexSeven,
  getInternationalPriceNuqlium
} from '../shared/utils';

const randomStringAll = randomString();

const internationalPrice = getInternationalPriceNuqlium();

/* NQ DATA API */

/* Brands All Feed */
export const brandsAllFeed = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/cats/' +
    devOrProd +
    '/index.php?v=' +
    randomStringAll,
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSeven(),
    id: 'brands',
    output: 'json',
    'settings[mode]': 'web',
    'includes[0]': 'url',
    'includes[1]': 'total'
  })
};

export const brandDirectoryPage = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
    devOrProd +
    '/index.php?v=' +
    randomStringAll,
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSeven(),
    output: 'json',
    pagetype: 'pages',
    pagekey: 'brand-directory',
    'settings[mode]': 'web'
  })
};
